import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LinkedinService {
  url = ' https://api.linkedin.com/v2/companySearch';

  constructor(private http: HttpClient) { }

  getTestCompanyFromLinkedInByName(q: string): void {
    this.http.get(this.url, { params: { q }, withCredentials: true, responseType: 'json' }).toPromise();
  }
}
